import BaseViewController from "./base-view-controller";
import { loginToDashboard } from "../api/login";

class PliMembersViewController extends BaseViewController {
  handleButtonClick(name, text, action) {
    let errors;

    switch (name) {
      case "save_button":
        errors = this.validateSecureYourAccountScreen().filter(
          error => !error.isValid
        );

        if (errors.length > 0) {
          const mappedErrors = {};
          errors.forEach(error => {
            if (!mappedErrors[[error.name]]) {
              mappedErrors[[error.name]] = [];
            }
            mappedErrors[[error.name]].push(error);
          });

          this.appData.setFieldValidation(mappedErrors);
        } else {
          super.handleButtonClick(name, text, action);
        }
        break;
      case "redirect_to_dashboard":
        loginToDashboard({
          username: this.appData.values.username,
          password: this.appData.values.password
        });
        break;
      case "continue_button":
        if (this.appData.values.member_id === "create_new_account") {
          window.location.href = "/registrations/new_benefits";
        } else if (this.appData.values.member_id.startsWith("sso_only")) {
          const memberField = this.screen.fields.find(
            field => field.name === "member_id"
          );
          const linkField = memberField.options.find(
            field => field.value === this.appData.values.member_id
          );
          const ssoUrl = linkField.links;
          window.location.href = ssoUrl;
        } else if (this.appData.values.member_id.startsWith("pending_")) {
          window.location.href = "/registrations/pending_accounts";
        } else {
          super.handleButtonClick(name, text, action);
        }
        break;
      case "goBackButton":
        window.location.href = "/registrations/get_started";
        break;
      case "resend_code":
      case "resend_link":
        this.resetFieldValidation();
        super.handleButtonClick(name, text, action);
        break;
      case "to_dashboard":
        window.location.href = "/homepage";
        break;
      case "update_password":
        errors = this.validateUpdatePasswordScreen().filter(
          error => !error.isValid
        );

        if (errors.length > 0) {
          const mappedErrors = {};
          errors.forEach(error => {
            if (!mappedErrors[[error.name]]) {
              mappedErrors[[error.name]] = [];
            }
            mappedErrors[[error.name]].push(error);
          });

          this.appData.setFieldValidation(mappedErrors);
        } else {
          super.handleButtonClick(name, text, action);
        }
        break;
      default:
        super.handleButtonClick(name, text, action);
        break;
    }
  }

  handleBackButtonClick() {
    if (this.screen.name === "SecureYourAccount") {
      super.handleBackButtonClick();
    }
  }

  delay(t, v) {
    return new Promise(function (resolve) {
      setTimeout(resolve.bind(null, v), t);
    });
  }

  preprocessScreenData() {
    if ((this.screen.params || "").includes("TDScreenOptionVerifyCodeScreen")) {
      const verificationCodeField = this.screen.fields.find(
        field => field.name === "verification_code"
      );
      if (
        verificationCodeField.data?.error &&
        !this.appData.fieldValidation[verificationCodeField.name]
      ) {
        this.appData.setFieldValidation({
          verification_code: [
            {
              name: verificationCodeField.name,
              title: verificationCodeField.title,
              isValid: false,
              isRequired: true,
              errorMessage:
                this.appData.settings.translations.invalid_code_entry
            }
          ]
        });
      }
    }
  }

  validateUpdatePasswordScreen() {
    let errors = [];
    errors = errors.concat(this.validatePassword());
    errors = errors.concat(this.validatePasswordConfirmation());
    errors = errors.concat(this.validateUpdatePasswordAnswer());
    return errors;
  }

  validateSecureYourAccountScreen() {
    let errors = [];
    errors = errors.concat(this.validateUsername());
    errors = errors.concat(this.validatePassword());
    errors = errors.concat(this.validatePasswordConfirmation());
    errors = errors.concat(this.validateSQ());
    return errors;
  }

  validateUsername() {
    const usernameField = this.screen.fields.find(
      field => field.name === "username"
    );
    const usernameValue = this.appData.values.username;
    if (!usernameValue) {
      return {
        name: usernameField.name,
        title: usernameField.title,
        isValid: false,
        isRequired: true,
        errorMessage: this.generateErrorMessage(usernameField.title)
      };
    }

    return [];
  }

  validatePassword() {
    const passwordField = this.screen.fields.find(
      field => field.name === "password"
    );
    const passwordValue = this.appData.values.password;
    return (passwordField.data?.regex_validation || []).map(regexItem => {
      return this.validateRegex(regexItem, passwordField, passwordValue);
    });
  }

  validatePasswordConfirmation() {
    const passwordConfirmationField = this.screen.fields.find(
      field => field.name === "password_confirmation"
    );
    const passwordValue = this.appData.values.password;

    const passwordConfirmationValue = this.appData.values.password_confirmation;
    return passwordValue === passwordConfirmationValue
      ? []
      : {
          name: passwordConfirmationField.name,
          title: passwordConfirmationField.title,
          isValid: false,
          errorMessage: passwordConfirmationField.data?.error_message,
          value: passwordConfirmationValue
        };
  }

  validateUpdatePasswordAnswer() {
    const answerField = this.screen.fields.find(
      field => field.name === "security_response"
    );
    const answerValue = this.appData.values.security_response;
    return (answerField.data?.regex_validation || []).map(regexItem => {
      return this.validateRegex(regexItem, answerField, answerValue);
    });
  }

  validateSQ() {
    const errors = [];
    const takenSQValues = [];
    // eslint-disable-next-line no-restricted-syntax
    for (const [key, value] of Object.entries(this.appData.values)) {
      if (value === "" && /^security_questions\..*\.question_id$/.test(key)) {
        const securityQuestionField = this.screen.fields.find(
          field => field.name === key
        );
        errors.push({
          name: securityQuestionField.name,
          title: securityQuestionField.title,
          isValid: false,
          isRequired: true,
          errorMessage: this.generateErrorMessage(securityQuestionField.title)
        });
      } else if (
        /^security_questions\..*\.question_id$/.test(key) &&
        value !== ""
      ) {
        if (takenSQValues.includes(value)) {
          const securityQuestionField = this.screen.fields.find(
            field => field.name === key
          );
          errors.push({
            name: securityQuestionField.name,
            title: securityQuestionField.title,
            isValid: false,
            isRequired: true,
            errorMessage:
              this.appData.settings.translations
                .duplicate_security_question_error
          });
        } else if (value) {
          const indexQ = key.split(".")[1];
          const responseFieldName = `security_questions.${indexQ}.security_response`;
          const responseField = this.screen.fields.find(
            field => field.name === responseFieldName
          );
          const responseValue = this.appData.values[responseFieldName];
          if (!responseValue) {
            errors.push({
              name: responseField.name,
              title: responseField.title,
              isValid: false,
              isRequired: true,
              errorMessage: this.generateErrorMessage(responseField.title)
            });
          } else {
            (responseField.data?.regex_validation || []).forEach(regexItem => {
              errors.push(
                this.validateRegex(regexItem, responseField, responseValue)
              );
            });
          }
        }
        takenSQValues.push(value);
      }
    }

    return errors;
  }

  validateRegex(regexItem, field, value) {
    const isValid = new RegExp(regexItem.pattern).test(value);
    return {
      name: field.name,
      title: field.title,
      isValid: regexItem.type === "inverse_find" ? !isValid : isValid,
      errorMessage: regexItem.error,
      value
    };
  }

  resetFieldValidation() {
    Object.keys(this.appData.fieldValidation).forEach(
      field => delete this.appData.fieldValidation[field]
    );
  }

  generateErrorMessage(fieldTitle) {
    if (fieldTitle) {
      return this.appData.settings.translations.field_missing.replace(
        "%field_name%",
        fieldTitle
      );
    } else {
      return this.appData.settings.translations.field_missing_general;
    }
  }
}

export default PliMembersViewController;
